import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface ValidationErrors {
  [key: string]: string;
}

interface FormValidationState {
  errors: ValidationErrors;
  showValidationMessage: boolean;
  showSuccessMessage: boolean;
}


const initialState: FormValidationState = {
  errors: {},
  showValidationMessage: false,
  showSuccessMessage: false
};



const formValidationSlice = createSlice({
  name: 'formValidation',
  initialState,
  reducers: {
    setValidationErrors(state, action: PayloadAction<ValidationErrors>) {
      state.errors = action.payload;
    },
    clearValidationError(state, action: PayloadAction<string>) {
      const { [action.payload]: _, ...remainingErrors } = state.errors;
      state.errors = remainingErrors;
    },
    setShowValidationMessage(state, action: PayloadAction<boolean>) {
      state.showValidationMessage = action.payload;
    },
    setShowSuccessMessage(state, action: PayloadAction<boolean>) {
      state.showSuccessMessage = action.payload;
    }

  }
});

export const { 
  setValidationErrors, 
  clearValidationError, 
  setShowValidationMessage,setShowSuccessMessage  
} = formValidationSlice.actions;

export default formValidationSlice.reducer;
